import React from 'react';
import { Pencil } from 'lucide-react';

/**
 * How many bultos a shipment has, in the DETALLES column of the deliveries
 * table.
 *
 * While the shipment can still change, the count opens the same "set the
 * total" modal as the order detail. Otherwise it is plain text.
 *
 * @param {object} props
 * @param {number} props.count
 * @param {boolean} [props.editable=false]
 * @param {() => void} [props.onEdit]
 */
export const ItemsCountCell = ({ count, editable = false, onEdit }) => {
  if (!editable) {
    return <span className="text-xs text-text-muted mt-0.5">{count} bulto{count !== 1 ? 's' : ''}</span>;
  }

  // Text-like rather than a `Button`: its padding and type size would make the
  // row taller and push the count out of line with the reference above it.
  return (
    <button
      type="button"
      onClick={onEdit}
      title="Editar bultos"
      data-testid="delivery-items-count"
      className="flex items-center gap-1 w-fit text-xs text-text-muted hover:text-ninja-green mt-0.5 transition-colors"
    >
      {count} bulto{count !== 1 ? 's' : ''}
      <Pencil size={11} className="shrink-0" />
    </button>
  );
};
